import styled from 'styled-components';

export const BubbleContainer = styled.div<{ isUser: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};
  align-items: flex-end;
  gap: 8px;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const AvatarWrapper = styled.div`
  flex-shrink: 0;

  .ant-avatar {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.bot-avatar .ant-avatar img {
    width: 18px !important;
    height: 18px !important;
    object-fit: contain;
    margin: 0 !important;
  }
`;

export const BubbleContent = styled.div<{ isUser: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};
  max-width: 70%;
`;

export const Bubble = styled.div<{ isUser: boolean }>`
  padding: 10px 14px;
  border-radius: 18px;
  background: ${(props) =>
    props.isUser ? 'linear-gradient(135deg, #1F2D3A 0%, #2A3F52 50%, #1F2D3A 100%)' : '#ffffff'};
  background-size: ${(props) => (props.isUser ? '200% 100%' : 'auto')};
  animation: ${(props) => (props.isUser ? 'shimmer 3s ease-in-out infinite' : 'none')};
  color: ${(props) => (props.isUser ? '#fff' : '#333')};
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  line-height: 1.5;
  font-size: 14px;

  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    50% {
      background-position: 100% 0%;
    }
    100% {
      background-position: 0% 0%;
    }
  }

  ${(props) =>
    !props.isUser &&
    `
    border-top-left-radius: 4px;
  `}

  ${(props) =>
    props.isUser &&
    `
    border-top-right-radius: 4px;
  `}
`;

export const Timestamp = styled.span`
  font-size: 11px;
  color: #999;
  margin-top: 4px;
  padding: 0 4px;
`;

export const TypingIndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TypingDots = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 14px;
  background: #ffffff;
  border-radius: 18px;
  border-top-left-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Dot = styled.div<{ delay: number }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #999;
  animation: bounce 1.4s infinite ease-in-out;
  animation-delay: ${(props) => props.delay}s;

  @keyframes bounce {
    0%,
    60%,
    100% {
      transform: translateY(0);
    }
    30% {
      transform: translateY(-10px);
    }
  }
`;
